module.exports = __webpack_public_path__ + "static/salon-de-pasajeros---acabado-lateral-c23992c8c8dd4f0e7ed87489588c8283.jpg";